import { lazy } from "react";

const create = lazy(() => import("./Create").then(m => ({ default: m.ShareClassCreate })));
const edit = lazy(() => import("./Edit").then(m => ({ default: m.ShareClassEdit })));

export default { create, edit };
